// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"228":"c1f9edbb","312":"b2d30cc6"}[chunkId] + ".chunk.js");